import throttle from 'lodash.throttle';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Actions from './actions';
import { ClearCache } from './components/ClearCache';
import Loading from './components/Loading/Loading';
import AgeGate from './containers/AgeGate';
import Contact from './containers/Contact';
import Footer from './containers/Footer';
import Header from './containers/Header';
import HomePage from './containers/Home';
import LeadershipPage from './containers/Leadership';
import AboutusPage from './containers/AboutUs';
import News from './containers/News';
import NewsArticle from './containers/NewsArticle';
import PageNotFound from './containers/NotFound';
import OurCompaniesPage from './containers/OurCompanies';
import OurCompaniesDetailPage from './containers/OurCompaniesDetail';
import Scroll from './containers/Scroll';
import StaticPage from './containers/StaticPage';
import { AppContext } from './Context';
import { IRootState } from './definitions/root';
import { FETCH_CONFIG, BOT_PATTERN } from './constants/actions';
import { TAPIRequestCanceller } from './services/api';

class Root extends Component<any, IRootState> {
  configRequest: TAPIRequestCanceller;

  state = {
    app: {
      loadingState: false,
      windowDimensions: {
        width: window.innerWidth,
        height: window.innerHeight
      },
      isMobile: (window.innerWidth < 768),
      isTablet: (window.innerWidth <= 1200)
    },
    menus: {
      header: [],
      footer: []
    }
  };

  constructor(props) {
    super(props);
    window.addEventListener('resize', this.updateDimensions);
  }

  updateDimensions = throttle(() => {
    const newDimensions = {
      width: window.innerWidth,
      height: window.innerHeight
    };

    this.setState({
      app: {
        windowDimensions: newDimensions,
        isMobile: (newDimensions.width < 768),
        isTablet: (newDimensions.width <= 1024)
      }
    });
  }, 2000);

  get isBot(): boolean {
    return new RegExp(BOT_PATTERN, 'i').test(navigator.userAgent) ||
      !!window.location.href.match(/purplemonkeydishwasher/i);
  }

  get ageGateActive(): boolean {
    return this.props.ageGate.validated || this.isBot;
  }

  componentDidMount() {
    this.configRequest = Actions.get(this.props.dispatch, FETCH_CONFIG);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    this.configRequest.cancel('Root component unmounted');
  }

  render() {
    const ageGateRoutes = (
      <Switch>
        <Route exact path="/" component={AgeGate} />
        <Route exact path="/(privacy-policy|terms-of-use|about-ads)" component={StaticPage} />
        <Route exact path="/cache" component={ClearCache} />
        <Route component={AgeGate} />
      </Switch>
    );

    const appRoutes = (
      <React.Fragment>
        <Header />
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/index.html" component={HomePage} />
          <Route exact path="/our-companies" component={OurCompaniesPage} />
          <Route exact path="/our-companies/:company" component={OurCompaniesDetailPage} />
          <Route exact path="/leadership" component={LeadershipPage} />
          <Route exact path="/aboutus" component={AboutusPage} />
          <Route exact strict path="/news" component={News} />
          <Route exact path="/news/:url" component={NewsArticle} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/not-found" component={PageNotFound} />
          <Route exact path="/cache" component={ClearCache} />
          <Route component={StaticPage} />
        </Switch>
      </React.Fragment>
    );

    return (
      <AppContext.Provider value={this.state}>
        <Router>
          <Scroll>
              <Loading isLoading={this.props.loading}/>
              {this.ageGateActive
                ? appRoutes
                : ageGateRoutes
              }
              <Footer />
              <div className="overlay" />
          </Scroll>
        </Router>
      </AppContext.Provider>
    );
  }
}

const state = ({ loading: { status }, ageGate }) => ({
  loading: status,
  ageGate
});

export default connect(state)(Root);



// WEBPACK FOOTER //
// ./src/Root.tsx